import { render } from "./NWGDashboardPage.vue?vue&type=template&id=aeeed184&ts=true"
import script from "./NWGDashboardPage.vue?vue&type=script&lang=ts"
export * from "./NWGDashboardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__